import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'elc-service';
import { Row } from 'elc-grid';
import { ContentSpacing } from 'elc-base-theme';
import { classes } from '../../../utils/Classes';

const StyledResultsRow = styled(Row)`
    padding-top: ${ContentSpacing.space20};
    padding-bottom: ${ContentSpacing.space12};
`;

export interface IProductsNo {
    productsNumber: number;
    translations?: IProductsNoTranlslations;
}

interface IProductsNoTranlslations {
    resultsLabel: string;
}

@translate(['resultsLabel'])
export class ProductsNo extends React.Component<IProductsNo> {
    render() {
        const styledResultsRowClassnames: string = classes('styled-filters-result-row');
        const styledResultsLabelClassnames: string = classes('styled-filters-results-label');

        return (
            <StyledResultsRow className={styledResultsRowClassnames}>
                <div className={styledResultsLabelClassnames}>
                    {this.props.productsNumber} {this.props.translations?.resultsLabel}
                </div>
            </StyledResultsRow>
        );
    }
}
